import { DataBuffer } from "../../Buffers/dataBuffer";
/** @internal */
export class WebGLDataBuffer extends DataBuffer {
    /** @internal */
    constructor(resource) {
        super();
        this._buffer = resource;
    }
    /** @internal */
    get underlyingResource() {
        return this._buffer;
    }
}
//# sourceMappingURL=webGLDataBuffer.js.map